import React, { useEffect, useState } from "react";
import { Beat } from "../../../redux/reducers/spinner";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../redux/actions";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { removePlusSign } from "../../helper/phoneNumber";

function ChangePhone({ employeeId }) {
  const dispatch = useDispatch();

  const employee_id = employeeId;
  const singleEmployee = useSelector((state) => state.admin.singleEmployee);
  const updating = useSelector((state) => state.users.updating);

  const [open, setOpen] = React.useState(false);
  const [submitted, setSubmitted] = useState(false);

 
  const [employee_phone, setEmployeePhone] = useState("");

  useEffect(() => {
    if (singleEmployee?.employee_phone) {
      setEmployeePhone(singleEmployee.employee_phone);
    }
  }, [singleEmployee.employee_phone]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);

    const cleanedPhone = removePlusSign(employee_phone);

    // dispatch action to change phone
    dispatch(
      userActions.changePhone({
        id: employee_id,
        employee_phone: cleanedPhone,
      })
    );
    handleClose();
  };

  return (
    <div>
      <MDBContainer>
        <MDBBtn color="primary" onClick={() => setOpen(true)}>
          Change Phone Number
        </MDBBtn>
        <MDBModal isOpen={open} toggle={handleClose}>
          <form name="form" onSubmit={handleSubmit}>
            <MDBModalHeader toggle={handleClose}>
              Change your Phone Number
            </MDBModalHeader>
            <MDBModalBody>
              <label htmlFor="phone">New Phone Number</label>
              <PhoneInput
                defaultCountry="NG"
                value={employee_phone}
                onChange={setEmployeePhone}
                className={
                  "form-control form-control-rounded" +
                  (submitted && !employee_phone ? " is-invalid" : "")
                }
              />
              {submitted && !employee_phone && (
                <div className="invalid-feedback">
                  New Phone Number is required
                </div>
              )}
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={() => setOpen(false)}>
                Close
              </MDBBtn>
              <MDBBtn color="primary" type="submit">
                {updating === true ? <Beat loading={updating} /> : "Save"}
              </MDBBtn>
            </MDBModalFooter>
          </form>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default ChangePhone;
